import React, { useState, useMemo } from "react";
import { Button } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import Image1 from '../../assets/1.png'
import Image2 from '../../assets/2.png'
export default function StepCategory({ formData, setFormData, onNext, facilityData }) {
  const [selected, setSelected] = useState(formData.category || null);

  const categories = useMemo(() => {
    if (!facilityData?.data) return [];

    return Object.keys(facilityData.data).map((key) => ({
      id: key,
      label: key
        .replace(/([a-z])([A-Z])/g, "$1 $2") 
        .replace(/_/g, " ")             
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      icon: Image1,
    }));
  }, [facilityData]);

  const handleSelect = (cat) => {
    setSelected(cat.id);
    setFormData({ ...formData, category: cat.id });
  };

  return (
    <div className="step-category">
      <h2 className="step-title text-white">
        {/* We’d love to collaborate! <br />
        <span>Let us know what you’re after.</span> */}
      </h2>

      <p
        style={{
          fontWeight: 700,
          color: "#fff",
          marginBottom: "1.25rem",
          lineHeight: 1.5,
        }}
      >
        Same-day &amp; Next-day bookings are not available after 3 PM CST. Please
        schedule in advance to secure your preferred time.
      </p>

      <div className="card-grid">
        {categories.map((cat , index) => (
          <div
            key={cat.id}
            onClick={() => handleSelect(cat)}
            className={`card ${selected === cat.id ? "selected" : ""}`}
          >
            {selected === cat.id && (
              <CheckCircleTwoTone twoToneColor="#fc8c02" className="check-icon" />
            )}

            <div className="card-icon flex justify-center" >
              <img src={index == 1 ? Image1 : Image2} alt="image" />
            </div>
            <h3 className="card-title">{cat.label}</h3>
          </div>
        ))}
      </div>

      <Button
        type="primary"
        size="large"
        block
        disabled={!selected}
        onClick={onNext}
        className="btn-css"
      >
        Continue
      </Button>
    </div>
  );
}
